module.exports = __webpack_public_path__ + "static/media/design.5816f325.svg";